export enum OrderDetailId {
  OrderCreatedDate,
  Linesheets,
  Season,
  Year,
  Warehouse,
  DivisionCode,
  OrderDeliveryWindow,
  Event,
  OrderType,
}

type DetailsEditItem = {
  title: string
  content: React.ReactNode
  isEditable?: boolean
  ownTooltipText?: string
}

export type OrderDetailEditType = {
  id: OrderDetailId
} & DetailsEditItem
